import { Semaphore } from "@packages/core";

/** `fetch()`の同時実行数を制御するためのセマフォ */
export const NETWORK_SEMAPHORE = new Semaphore(8);
